import React, { Fragment } from "react";
import { NumberInput } from "react-admin";

const BaseballTeamStats = ({ className, side }) => {
  const s = (key) => `${side}.baseball.${key}`;
  return (
    <Fragment>
      <NumberInput label="Runs" source={s("runs")} className={className} />
      <NumberInput label="Hits" source={s("hits")} className={className} />
      <NumberInput label="Errors" source={s("errors")} className={className} />
    </Fragment>
  );
};

export default BaseballTeamStats;
